import React from 'react'

import CounterChart from '../../_shared/charts/counter/CounterChart'
import FormsCounterLoader, { useAllFormsCounter, useFormsCounter } from './_load/FormsCounterLoader'
import WidgetWrapper from '../../WidgetWrapper'

const Widget = props => {
  const { widget } = props
  const value = useFormsCounter()
  const all = useAllFormsCounter()

  return <CounterChart value={value} all={all} name={widget.name} {...widget.data} />
}

const Wrapper = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <FormsCounterLoader widget={widget}>
        <Widget widget={widget} />
      </FormsCounterLoader>
    </WidgetWrapper>
  )
}

export default Wrapper
